import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Toolbar,
  Dialog,
  AppBar,
  DialogTitle,
  IconButton,
  DialogContent,
  Divider,
  TextField,
  Drawer, Card, CardMedia, CardContent, 
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import logo from "../images/logo.jpg";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import "../App.css";
import StickyMenu from "./StickyMenu";
import Footer from "./Footer";
import PresidentialSuiteImg from '../images/banner1.jpg';
import Banner3 from '../images/banner3.jpg';
import image3 from "../images/r1.jpeg";
import image1 from "../images/room1.jpeg";
import image2 from "../images/room2.jpeg";
import { Link } from "react-router-dom";


const accommodationsData = [
  {
    label: "Presidential Suite",
    cards: [
      { image: PresidentialSuiteImg, roomType: "Room with Breakfast", rate: "7500++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "8000++ Taka" },
      { image: image3, roomType: "Room with Breakfast", rate: "8500++ Taka" },
      { image: image1, roomType: "Room with Breakfast", rate: "9000++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "9500++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "10000++ Taka" },
    ],
  },
  {
    label: "Executive Suite",
    cards: [
      { image: Banner3, roomType: "Room with Breakfast", rate: "5500++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "6000++ Taka" },
      { image: image1, roomType: "Room with Breakfast", rate: "6500++ Taka" },
      { image: image3, roomType: "Room with Breakfast", rate: "7000++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "7500++ Taka" },
      { image: PresidentialSuiteImg, roomType: "Room with Breakfast", rate: "8000++ Taka" },
    ],
  },
  {
    label: "City Suite",
    cards: [
      { image: Banner3, roomType: "Room with Breakfast", rate: "4000++ Taka" },
      { image: PresidentialSuiteImg, roomType: "Room with Breakfast", rate: "4200++ Taka" },
      { image: image3, roomType: "Room with Breakfast", rate: "4300++ Taka" },
      { image: image1, roomType: "Room with Breakfast", rate: "4400++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "4500++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "4600++ Taka" },
    ],
  },
  {
    label: "Super Deluxe",
    cards: [
      { image: image1, roomType: "Room with Breakfast", rate: "9000++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "9500++ Taka" },
      { image: image3, roomType: "Room with Breakfast", rate: "10000++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "10500++ Taka" },
      { image: PresidentialSuiteImg, roomType: "Room with Breakfast", rate: "11000++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "11500++ Taka" },
    ],
  },
  {
    label: "Standard Twin",
    cards: [
      { image: image1, roomType: "Room with Breakfast", rate: "3500++ Taka" },
      { image: Banner3, roomType: "Room with Breakfast", rate: "3700++ Taka" },
      { image: PresidentialSuiteImg, roomType: "Room with Breakfast", rate: "3800++ Taka" },
      { image: image2, roomType: "Room with Breakfast", rate: "4000++ Taka" },
      { image: image3, roomType: "Room with Breakfast", rate: "4200++ Taka" },
      { image: image1, roomType: "Room with Breakfast", rate: "4400++ Taka" },
    ],
  },
];


const Accommodation = () => {
  const navigation = ["Home", "Accommodation", "Meeting And Events", "Gallery"];
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const [showAnimation, setShowAnimation] = useState(true); // State to control animation
  const [lastScrollTop, setLastScrollTop] = useState(0); // Track last scroll position
  const navigate = useNavigate(); // Initialize the navigate function

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;

      // Check if scrolling up
      if (currentScrollTop < lastScrollTop) {
        setShowAnimation(true); // Trigger animation
      } else {
        setShowAnimation(false); // Hide animation
      }

      setLastScrollTop(currentScrollTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleContactModal = (open) => () => {
    setContactModalOpen(open);
  };


  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [cursorScale, setCursorScale] = useState(false);

  useEffect(() => {
    const moveCursor = (e) => {
      setCursorPosition({ x: e.clientX, y: e.clientY });
    };

    const enlargeCursor = () => setCursorScale(true);
    const shrinkCursor = () => setCursorScale(false);

    window.addEventListener("mousemove", moveCursor);
    document.querySelectorAll("a, button").forEach((el) => {
      el.addEventListener("mouseenter", enlargeCursor);
      el.addEventListener("mouseleave", shrinkCursor);
    });

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      document.querySelectorAll("a, button").forEach((el) => {
        el.removeEventListener("mouseenter", enlargeCursor);
        el.removeEventListener("mouseleave", shrinkCursor);
      });
    };
  }, []);


  const [selected, setSelected] = useState(accommodationsData[0]); // Default to the first button

  const handleButtonClick = (accommodation) => {
    setSelected(accommodation);
  };




  return (

    /* Custom Cursor */
    <>

    <StickyMenu />

      <div
        className={`custom-cursor ${cursorScale ? "cursor-large" : ""}`}
        style={{
          top: `${cursorPosition.y}px`,
          left: `${cursorPosition.x}px`,
        }}
      ></div>

      <AppBar
        position="absolute"
        sx={{
          top: "0",
          // backgroundColor: "transparent",
          backgroundColor: 'black',
          boxShadow: "none",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 2, sm: 4 },
            py: { xs: 1, sm: 2 },
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
          <Link to="/" style={{ textDecoration: "none" , color: 'black'}}>
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "80px",
                marginRight: "20px",
              }}
            /> </Link>

            <Typography
            sx={{ fontFamily: "SangBleu Empire Trial",
              fontWeight: "bold",  fontSize: "20px", textTransform: 'uppercase',
              // lineHeight: "1",
                // display: "block",
              }}
            >  Hotel City Plaza International </Typography>
          </Box>

          {/* Navigation Menu */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" }, // Hide menu on small screens
              flexDirection: { sm: "row" },
              alignItems: "center",
              // gap: { xs: "10px", sm: "20px" },
              // padding: { xs: "4px", sm: "8px 16px" },
              backgroundColor: "#f9f9f9",
              height: "45px",
              borderRadius: "8px",
              animation: showAnimation ? "slideIn 0.6s ease-out" : "none", // Apply animation based on state
              "@keyframes slideIn": {
                "0%": {
                  transform: "translateX(100%)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { sm: "row" },
                gap: "10px",
                height: "45px",
              }}
            >
              {navigation.map((item, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  onClick={() => {
                    if (item === "Home") {
                      navigate("/"); // Redirect to the Accommodation page
                    }
                    if (item === "Accommodation") {
                      navigate("/accomodation"); // Redirect to the Accommodation page
                    }
                    if (item === "Meeting And Events") {
                      navigate("/meetingEvents"); // Redirect to the Accommodation page
                    }
                    if (item === "Gallery") {
                      navigate("/"); // Redirect to the Accommodation page
                      }
                  }}
                  sx={{
                    color: "black",
                    fontWeight: 500,
                    padding: "10px 15px",
                    cursor: "pointer", // Add pointer cursor for better UX
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#fff",
                      // backgroundColor: "#008345",
                      backgroundColor: '#FF0000',
                      height: "45px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                  style={{
                    fontFamily: "SangBleu Empire Trial",
                    fontWeight: "bold",
                  }}
                >
                  {item}
                </Typography>
              ))}
            </Box>

           

            <Button
              sx={{
                //  color: "black",
                fontFamily: "SangBleu Empire Trial",
                fontWeight: "bold",

                padding: "10px 15px",
                transition: "all 0.3s ease",
                backgroundColor: "#008345",
                textTransform: "none",
                color: "white",
                borderRadius: 0,
                "&:hover": {
                  //  color: "#fff",
                  backgroundColor: "#008345",
                  // borderRadius: "4px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                },
              }}
              style={{ fontWeight: 900 }}
              onClick={toggleContactModal(true)}
            >
              Contact
            </Button>
          </Box>

          {/* Contact Modal */}
          <Dialog
            open={contactModalOpen}
            onClose={toggleContactModal(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontFamily: "SangBleu Empire Trial",
                fontWeight: "bold",
                pt: 2,
                pb: 1,
              }}
            >
              Contact Us
              <IconButton
                onClick={toggleContactModal(false)}
                sx={{ color: "gray" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  minWidth: "320px",
                  maxHeight: "720px",
                  borderRadius: 2,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Grid container spacing={2}>
                  {/* Left Section: Contact Information */}
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontFamily: "SangBleu Empire Trial",
                        }}
                      >
                        {/* Contact Information */}
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      {/* Call Us Section */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mb: 3,
                          p: 3,
                          backgroundColor: "#f0f8f5",
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            fontFamily: "SangBleu Empire Trial",
                            color: "#333",
                          }}
                        >
                          Call Us:
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#555",
                            fontFamily: "SangBleu Empire Trial",
                          }}
                        >
                          01795-477977
                        </Typography>
                      </Box>
                      {/* Email Us Section */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mb: 3,
                          p: 3,
                          backgroundColor: "#f0f8f5",
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            fontFamily: "SangBleu Empire Trial",
                            color: "#333",
                          }}
                        >
                          Email Us:
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#555",
                            fontFamily: "SangBleu Empire Trial",
                          }}
                        >
                          info@hotelcityplazabd.com
                        </Typography>
                      </Box>
                      {/* Location Section */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 3,
                          backgroundColor: "#f0f8f5",
                          borderRadius: 2,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            fontFamily: "SangBleu Empire Trial",
                            color: "#333",
                          }}
                        >
                          Location:
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#555",
                            fontFamily: "SangBleu Empire Trial",
                          }}
                        >
                          Gohata Road, Jessore, Jessore, Bangladesh
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Right Section: Contact Form */}
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          mb: 4,
                          textAlign: "center",
                          fontFamily: "SangBleu Empire Trial",
                          fontWeight: "bold",
                        }}
                      >
                        {/* Contact Us */}
                      </Typography>
                      <TextField
                        fullWidth
                        label="Your Name"
                        name="name"
                        required
                        sx={{ mb: 3, fontFamily: "SangBleu Empire Trial" }}
                      />
                      <TextField
                        fullWidth
                        label="Email Address"
                        name="email"
                        type="email"
                        required
                        sx={{ mb: 3 }}
                      />
                      <TextField
                        fullWidth
                        label="Your Message"
                        name="message"
                        multiline
                        rows={4}
                        required
                        sx={{ mb: 3 }}
                      />
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                          py: 1.5,
                          backgroundColor: "#008345",
                          color: "#fff",
                          fontFamily: "SangBleu Empire Trial",
                        }}
                      >
                        Send Message
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            {/* <DialogActions>
<Button onClick={toggleContactModal(false)}>Cancel</Button>
</DialogActions> */}
          </Dialog>

          {/* Drawer Menu Icon for Small Screens */}
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            sx={{
              display: { xs: "block", md: "none" },
              color: "white",
              // border: '2px #008345',
              // backgroundColor: 'white',
            }} // Only show on small screens
            onClick={toggleDrawer(true)}
          >
            <MenuIcon sx={{ borderRadius: "none" }} />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: 250,
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Menu</Typography>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {navigation.map((item, index) => (
            <Typography
              key={index}
              variant="body1"
              onClick={() => {
                if (item === "Home") {
                  navigate("/");
                }
                if (item === "Accommodation") {
                  navigate("/accomodation"); // Redirect to the Accommodation page
                }
                if (item === "Meeting And Events") {
                  navigate("/meetingEvents"); 
                }
                if (item === "Gallery") {
                  navigate("/"); 
                  }
              }}
              sx={{
                fontWeight: 500,
                padding: "10px 15px",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: "#008345",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                },
              }}
              style={{
                fontFamily: "SangBleu Empire Trial",
                fontWeight: "bold",
              }}
            >
              {item}
            </Typography>
          ))}

          <Button
            sx={{
              //  color: "black",
              fontFamily: "SangBleu Empire Trial",
              fontWeight: "bold",

              //  padding: "10px 15px",
              transition: "all 0.3s ease",
              backgroundColor: "#008345",
              textTransform: "none",
              color: "white",
              textAlign: "left",
              borderRadius: 0,
              "&:hover": {
                //  color: "#fff",
                backgroundColor: "#008345",
                // borderRadius: "4px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              },
            }}
            style={{ fontWeight: 900 }}
            onClick={toggleContactModal(true)}
          >
            Contact
          </Button>
        </Box>
      </Drawer>

      
      {/* Accomodation main  */}
      <Box
      sx={{
        py: 6,
        textAlign: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "white",
          fontFamily: "SangBleu Empire Trial",
          mt: 12,
          position: "relative",
          display: "inline-block",
          "&:after": {
            content: '""',
            position: "absolute",
            bottom: "-8px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "50px",
            height: "3px",
            backgroundColor: "#008345",
          },
        }}
      >
        Accommodation
      </Typography>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="center" mt={4}>
        {accommodationsData.map((item) => (
          <Grid item key={item.label}>
            <Button
              variant={selected.label === item.label ? "contained" : "outlined"}
              onClick={() => handleButtonClick(item)}
              sx={{
                px: 2,
                py: 1.5,
                fontWeight: "bold",
                borderRadius: "8px",
                textTransform: "none",
                fontSize: '18px',
                // color: selected.label === item.label ? "white" : "white",
                // backgroundColor: selected.label === item.label ? "#008345" : "transparent",
                // border: "1px solid white",
                backgroundColor: selected.label === item.label ? "white" : "transparent",
                color: selected.label === item.label ? "#008345" : "white",
                border: "1px solid white",
                fontFamily: "SangBleu Empire Trial",
                "&:hover": {
                  // backgroundColor: selected.label === item.label ? "transparent" : "#008345",
                  backgroundColor: selected.label === item.label ? "#008345" : "#008345",
                  color: "#fff", 
                },
              }}
            >
              {item.label}
            </Button>
          </Grid>
        ))}
      </Grid>

      {/* Cards Section */}
      <Box sx={{ mx: 8 }}>
  <Grid container spacing={4} mt={4} justifyContent="center">
    {selected.cards.map((card, index) => (
      <Grid item key={index} xs={12} sm={6} md={6}>
        <Card
          sx={{
            // borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
           
            
            position: "relative",
          }}
        >
          {/* Full-Cover Image Section */}
          <CardMedia
            component="img"
            image={card.image}
            alt={selected.label}
            sx={{
              height: 500,
              objectFit: "cover",
              filter: "brightness(0.75)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
              transform: "scale(1.05)",
              boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.2)",
            },
            }}
          />

          {/* Overlay Text Section */}
          <CardContent
  sx={{
              position: "absolute",
              top: { xs: "65%", sm: "50%", md: "76%" }, // Adjust width based on screen size
   
    left: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column", // Default to vertical stacking
    justifyContent: "space-between",
    alignItems: "center",
    px: 5,
    py: 2,
    textAlign: "left",
    color: "black",
    background: "rgba(255, 255, 255, 0.7)", // Transparent background overlay
  }}
>
  <Grid container spacing={2} alignItems="center">
    {/* Typography Section on Left */}
    <Grid
      item
      xs={12}
      sm={8}
      sx={{
        textAlign: { xs: "center", sm: "left" }, // Center-align text on extra small and mobile devices
        marginBottom: { xs: 1, sm: 0 }, // Add spacing on smaller screens
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          marginBottom: { xs: 1, sm: 0 },
          fontSize: { xs: "1rem", sm: "1.25rem" }, // Adjust font size for smaller screens
        }}
      >
        {selected.label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          marginBottom: 0.5,
          fontSize: { xs: "0.85rem", sm: "1rem" }, // Responsive font size
        }}
      >
        Room Type: {card.roomType}
      </Typography>
      <Typography
        variant="body2"
        color="error"
        sx={{
          fontSize: { xs: "0.85rem", sm: "1rem" }, // Responsive font size
        }}
      >
        Rate: {card.rate}
      </Typography>
    </Grid>

    {/* Arrow Icon on Right */}
    <Grid
      item
      xs={12}
      sm={4}
      sx={{
        display: "flex",
        justifyContent: { xs: "center", sm: "flex-end" }, // Center the button on small screens
        alignItems: "center",
        marginTop: { xs: 1, sm: 0 }, // Add spacing on smaller screens
      }}
    >
      <IconButton
        sx={{
          backgroundColor: "#008345",
          color: "#fff",
          width: { xs: 40, sm: 48 }, // Adjust button size for smaller screens
          height: { xs: 40, sm: 48 },
          "&:hover": {
            backgroundColor: "#005c2a",
          },
        }}
      >
        <ArrowForwardIcon
          sx={{
            fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Adjust icon size for smaller screens
          }}
        />
      </IconButton>
    </Grid>
  </Grid>
          </CardContent>

        </Card>
      </Grid>
    ))}
  </Grid>
      </Box>


        
      </Box>
    
    <Footer />


    </>
  );
};

export default Accommodation;
